import Vue from 'vue';

export class TrackingHandler {
  static getModalInfo(modalId) {
    const modalElement = document.getElementById(modalId);

    return {
      element: modalElement,
      goalPath: '/virtual/signup/',
      modalDescription: modalElement.dataset.modalDescription,
      modalHeader: modalElement.dataset.modalHeader,
      modalImage: modalElement.dataset.modalImage,
      modalName: modalElement.dataset.modalName,
      modalTags: modalElement.dataset.modalTags,
      modalTest: modalElement.dataset.modalTest,
      modalTestStartDate: modalElement.dataset.modalTestStartDate,
      modalCampaignName: modalElement.dataset.modalCampaignName,
      pageTitle: document.body.dataset.pageTitle,
      pageUid: document.body.dataset.pageUid,
      pathName: window.location.href.replace(/\?.*/, '').replace(/\#.*/, ''),
      payload: `${ modalElement.dataset.modalName } - Modal ${ modalElement.dataset.modalTest }`,
    };
  }

  static exitModalShown(modalId) {
    const modalInfo = TrackingHandler.getModalInfo(modalId);
    TrackingHandler.sendToRAM(modalInfo);
  }

  static sendToRAM(modalInfo, modalAction = '') {
    if (typeof window.Reedsy === 'undefined') return;
    if (typeof window.Reedsy.RAM === 'undefined') return;

    const eventName = (modalAction === 'submit') ? 'modal-submit' : 'modal-impression';

    const variables = {
      modalName: modalInfo.modalName,
      currentPath: modalInfo.pathName,
      testData: JSON.stringify([
        modalInfo.modalTest,
        modalInfo.modalTestStartDate,
        modalInfo.modalTags,
        modalInfo.pageUid,
      ]),
      modalHeader: modalInfo.modalHeader,
      modalDescription: modalInfo.modalDescription,
      modalImage: modalInfo.modalImage,
      pageTitle: modalInfo.pageTitle,
    };

    window.Reedsy.RAM.pushEvent(eventName, variables);
  }

  static trackEvent(modalId, eventName) {
    if (Vue.prototype.exitModalHandler) {
      Vue.prototype.exitModalHandler.hideModal();
    }

    const modalInfo = TrackingHandler.getModalInfo(modalId);
    TrackingHandler.sendToRAM(modalInfo, eventName);
  }
}

export default {
  install: function(Vue) {
    Vue.prototype.trackingHandler = TrackingHandler;
  },
};
